import styled from 'styled-components';
import { INFO } from '../theme';

export const Button = styled.button`
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  pointer-events: ${({ active }) => (active ? 'auto' : 'none')};
  background-color: transparent;
  color: ${INFO};
  border-radius: 3px;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid ${INFO};
  cursor: pointer;
`;

export const MarginButton = styled(Button)`
margin-right: 16px;
margin-bottom: 8px;
`;
